import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zzotdwypnkchlfardccu.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6b3Rkd3lwbmtjaGxmYXJkY2N1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI1NDIyMjgsImV4cCI6MjA0ODExODIyOH0.cKfb3Q4GEQh2zacha076lCjg9vN-_IPi26al5ln0904';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);